export enum FeedbackTypes {
	VerySad = "very-sad",
	Sad = "sad",
    Neutral = "neutral",
    Happy = "happy",
    VeryHappy = "very-happy"
}